export default "__VITE_ASSET__luQvei_f__"